/* ============================================
   AKI SEASON LOOKS — hotspot behaviour
   Moved from inline <script> in sections/aki-season-looks.liquid (2026-09-30).
   Safe to load more than once: document listeners are bound a single time.
============================================ */
(function () {
  'use strict';
  if (window.__akiSeasonLooks) return;
  window.__akiSeasonLooks = true;

  function close(spot) {
    spot.classList.remove('is-active', 'flip-up', 'flip-right');
    var toggle = spot.querySelector('.aki-hotspot__toggle');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function closeAll(except) {
    document.querySelectorAll('.aki-hotspot.is-active').forEach(function (spot) {
      if (spot !== except) close(spot);
    });
  }

  function open(spot) {
    var wrap = spot.closest('.aki-look__wrap');
    if (wrap) {
      var wrapRect = wrap.getBoundingClientRect();
      var spotRect = spot.getBoundingClientRect();
      var relY = (spotRect.top - wrapRect.top) / wrapRect.height;
      var relX = (spotRect.left - wrapRect.left) / wrapRect.width;
      if (relY > 0.58) spot.classList.add('flip-up');
      if (relX > 0.62) spot.classList.add('flip-right');
    }
    spot.classList.add('is-active');
    spot.querySelector('.aki-hotspot__toggle').setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.aki-hotspot__toggle');
    if (!toggle) {
      // Clicks inside an open card (the product link) keep it open.
      if (!e.target.closest('.aki-hotspot__card')) closeAll();
      return;
    }
    var spot = toggle.closest('.aki-hotspot');
    var wasActive = spot.classList.contains('is-active');
    closeAll(spot);
    if (wasActive) {
      close(spot);
    } else {
      open(spot);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var active = document.querySelector('.aki-hotspot.is-active');
    if (!active) return;
    close(active);
    var toggle = active.querySelector('.aki-hotspot__toggle');
    if (toggle) toggle.focus();
  });
})();
